import React, { useContext, useEffect, useState } from "react";
import Field from "../core/ui/forms/field";
import SessionContext from "SessionContext";
import { useHistory } from "react-router-dom";
import ConfirmSuccess from "../core/ui/confirm-success";
import UnsavedChanges from "partials/unsaved-changes";

export default function BillingCodeForm(props) {
  const session = useContext(SessionContext);
  const history = useHistory();
  const [modified, setModified] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [billingCode, setBillingCode] = useState();
  const [disableSave, setDisableSave] = useState(true);
  const [billingCodeEditing, setBillingCodeEditing] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);
  const [allowNavigateAway, setAllowNavigateAway] = useState(false);

  const [errors, setErrors] = useState({
    id: "",
    description: "",
  });

  function loadBillingCode(billing_code_id) {
    setLoaded(false);
    session
      .query("admin/get_billing_code", { id: billing_code_id })
      .then((response) => {
        setBillingCode(response);
        setBillingCodeEditing(response);
        setLoaded(true);
      });
  }

  useEffect(() => {
    if (props.args.billing_code_id) {
      loadBillingCode(props.args.billing_code_id);
    } else {
      setBillingCode({
        id: "",
        description: "",
      });
      setLoaded(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const storeOldValues = () => {
      if(billingCode.id !== billingCodeEditing.id) {
        setBillingCodeEditing(billingCode);
      }
    }

    const checkForEmpty = () => {
      if(!billingCode.description.length) {
        setDisableSave(true);
      } else {
        setDisableSave(false);
      }
    }

    const checkForChanges = () => {
      const hasChanged = JSON.stringify(billingCode) !== JSON.stringify(billingCodeEditing);
      if(hasChanged) {
        setDisableSave(false); 
        setModified(true);
      } else {
        setDisableSave(true);
        setModified(false);
      }
    }

    if(billingCode && Object.keys(billingCode).length !== 0) {
      storeOldValues();
      checkForEmpty();
      checkForChanges();
    } 
    
  }, [billingCode, billingCodeEditing])

  function onClickSave(ev) {
    ev.stopPropagation();
    ev.preventDefault();

    const newErrors = {};
    if (!billingCode.code) newErrors.code = "Required";
    if (!billingCode.description) newErrors.description = "Required";
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return;
    }
    setModified(false);
    setAllowNavigateAway(true);

    const newBillingCode = {
      ...billingCode,
    };

    if (!!newBillingCode.id) {
      session
        .command(
          "admin/update_billing_code",
          newBillingCode,
          {},
          { defaultErrorHandling: false }
        )
        .then((response) => {
          setBillingCode(response);
          setShowSuccess(true);
        })
        .then(() => {
          setTimeout(() => {
            setShowSuccess(false);
            history.push("admin-billing-codes");
          }, 2000);
        })
        .catch((error) => {
          console.log("BillingCode Update Failed", JSON.stringify(error));
        });
    } else {
      session
        .command(
          "admin/create_billing_code",
          newBillingCode,
          {},
          { defaultErrorHandling: false }
        )
        .then((response) => {
          setBillingCode(response);
          setShowSuccess(true);
        })
        .then(() => {
          setTimeout(() => {
            setShowSuccess(false);
            history.push("admin-billing-codes");
          }, 2000);
        })
        .catch((error) => {
          console.log("BillingCode Create Failed", JSON.stringify(error));
        });
    }
  }

  function setDescription(ev) {
    setBillingCode({ ...billingCode, description: ev.target.value });
    if (ev.target.value) {
      setErrors((prev) => delete prev.description);
      setModified(true);
    }
  }

  function goBack() {
    history.push("/admin-billing-codes");
  }

  return (
    loaded && (
      <div className="page admin-page billingCode-form-page" onSubmit={e => e.preventDefault()}>
        <div className="list-header sticky-page-header">
          <button className="new-button" onClick={goBack}>
            <i className="bi bi-chevron-left" /> Back
          </button>
          <h1>Billing Code</h1>
          <i className="spacer" />
          <div className="billingCode-form-buttons">
          <button className="new-button promote" onClick={onClickSave} disabled={disableSave}>
            Save Changes
          </button>
        </div>
        </div>
        <section className="billingCode-form-details">
          <Field
            label="* Code"
            className="billingCode-form-details-heading"
            error={errors.code}
          >
            {billingCode.code}
          </Field>
          <Field
            label="* Description"
            className="billingCode-form-details-heading"
            error={errors.description}
          >
            <input
              type="text"
              value={billingCode.description}
              className="billingCode-form-details-description"
              onChange={setDescription}
            />
          </Field>
        </section>
        <div>
          <UnsavedChanges hasUnsavedChanges={allowNavigateAway ? false : modified} />
          <ConfirmSuccess show={showSuccess} label="Billing Code Updated Successfully." />
        </div>
      </div>
    )
  );
}
